import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-TeamsPlus',
  templateUrl: './TeamsPlus.component.html',
  styleUrls: ['./TeamsPlus.component.scss']
})
export class TeamPlusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
